import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-obsidian px-4">
      <div className="glass-strong w-full max-w-md rounded-2xl p-10 text-center" data-testid="payment-cancel">
        <XCircle className="mx-auto mb-4 h-12 w-12 text-amber-400" />
        <h1 className="text-2xl text-amber-50">Checkout cancelled</h1>
        <p className="mt-2 text-sm text-amber-100/60">No charge was made. You can try again anytime.</p>
        <div className="mt-6 flex justify-center gap-3">
          <Link to="/vote" className="btn-gold">Back to Vote</Link>
          <Link to="/support" className="btn-ghost-gold">Support</Link>
        </div>
      </div>
    </div>
  );
}
